import * as components from './components';

export default [
  {
    path: '/accounting',
    component: components.ClaimsList,
    name: 'accounting',
    meta: { admin: true }
  }
];


// WEBPACK FOOTER //
// ./ClientApp/app/accounting/routes.js